import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import EmailVerificationPage from './EmailVerificationPage';

const VerifyEmailRouteHandler = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const status = searchParams.get('status');
  const email = searchParams.get('email');

  const handleNavigate = (page, data = {}) => {
    if (page === 'main') {
      navigate('/');
    } else if (page === 'login') {
      navigate('/login?verified=1', { replace: true });
    } else if (page === 'register') {
      navigate('/?auth=register');
    } else {
      navigate(`/?auth=${page}`, { state: data });
    }
  };

  return (
    <EmailVerificationPage 
      onNavigate={handleNavigate} 
      email={email || undefined}
      token={token || undefined}
      status={status || undefined}
    />
  );
};

export default VerifyEmailRouteHandler;

